import { InputAdornment, TextField } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';
import { makeStyles } from '@mui/styles';
import { COLORS } from 'theme/MainTheme';
import { RelationshipSuccessMessage } from './RelationshipSuccessMessage';
import {Mail} from 'components/icons';

const useStyles = makeStyles(() => ({
  emailIcon: {
    width: 25,
    color: COLORS.VIOLET
  },
  successMessage: {
    color: COLORS.GREEN,
    fontSize: 22,
    fontWeight: 'bold',
    paddingTop: 30,
    textAlign: 'center',
  },
  textField: {
    width: '100%',

    '& .MuiInputBase-root': {
      background: COLORS.LIGHTER_GREY,
    },
  },
}), { name: 'OnBoardingRelationshipTextField' });

type OnBoardingRelationshipTextFieldProps = {
  email: string;
  inError: boolean;
  relationshipHasBeenAdded: boolean;
  setEmail: (newEmail: string) => void;
};

const OnBoardingRelationshipTextField = ({
  email,
  inError,
  relationshipHasBeenAdded,
  setEmail,
}: OnBoardingRelationshipTextFieldProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  const helperText = inError ? (
    <FormattedMessage id="relationship.textfield.error" />
  ) : undefined;

  const placeholderText = intl.formatMessage({
    id: 'relationship.textfield.placeholder',
  });

  return (
    <>
      <TextField
        className={classes.textField}
        disabled={relationshipHasBeenAdded}
        error={inError}
        helperText={helperText}
        placeholder={placeholderText}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Mail className={classes.emailIcon} />
            </InputAdornment>
          ),
        }}
        value={email}
        variant="outlined"
        onChange={(e) => setEmail(e.target.value)}
      />

      <RelationshipSuccessMessage
        className={classes.successMessage}
        show={relationshipHasBeenAdded}
      />
    </>
  );
};

export default OnBoardingRelationshipTextField;
